import { WorkspacesComponent } from '@umd-dit/workspaces-component-react';
import { useAuth } from '../../context/AuthContext';

export default function OrganizationManagementPage() {
  const { selectedOrganizationId, selectOrganization, selectWorkspace, isAdmin } = useAuth();
  
  // Debug log the API URL
  console.log('[OrganizationManagementPage] Workspace API URL:', import.meta.env.VITE_WORKSPACES_API_URL);
  
  return (
    <div className="container mx-auto p-6">
      <WorkspacesComponent
        appId="legislative-review"
        viewType={isAdmin ? "global-admin" : "user"}
        workspacesApiUrl={import.meta.env.VITE_WORKSPACES_API_URL}
        selectedOrganizationId={selectedOrganizationId || undefined}
        debug={import.meta.env.VITE_WORKSPACES_DEBUG_LOGGING === 'true'}
        onOrganizationSelect={selectOrganization}
        onWorkspaceSelect={selectWorkspace}
      />
    </div>
  );
}